<template>
	
<div id='orderMade'>
<div class='loading' v-if='loadShow'>loading...</div>
<GoodsShortage v-if='selloutShow' :goodsMsg='selloutMsg'  @selloutShowFN="getMsgFormSellout"/>
<Alert  v-if='AlertShow' :alertMsg='alertMsg' />

<plugin />
<myAddress   @changeFN="changeAddressFN"  v-if='myAddressShow' />
<!-- 地址 -->
<div class="orderMadeAddress">
    <div class="container1">
        <div class="orderMadeAddresscontent" v-if='address.name' @click="changeAddress">
                  <div class="contentLeft">
                          <img  src="../assets/home-shortcut-address.png"  />
                  </div>
                  <div class="contentCenter">
                          <div class="contentCenterprovince">{{address.province_name + address.city_name + address.area_name}}</div>
                          <div class="contentCenteraddress">{{ address.address}}</div>
                          <div class="contentCenterName">
                                <div >{{address.name}}</div>
                                <div >{{address.phone}}</div>
                                <div >{{address.id_card}}</div>
                          </div>
                </div>
                <div class="contentRight">
                        <img v-if='!addressCount' src="../assets/icon-next2.png"/>
                </div>
        </div>
        <div class="content2" v-else   @click="changeAddress">
          <div style="font-size:0.8rem;margin-bottom:0.1rem;font-weight:600;">+</div>
          <div>还没有收货地址，点击添加</div>
        </div>
    </div>
</div>


<!-- 橘袋 -->
<div class="cart-box">

	<div v-for='cartItem in cartList'>	
   
          <!-- 橘袋信息 -->
          <div class="cart">
                <div class="cartImg">
                    <img :src="cartItem.img"/>
                </div>
                <div class="content">
                    <div class="title">{{cartItem.name}}{{cartItem.advance_str}} </div>
                    <div class="time" v-if='cartItem.source==2'>{{cartItem.num}}套</div>
                    <div class="time" v-else>{{cartItem.plan_title}}</div>
                    <div class="price"><span>¥ </span>{{cartItem.pay_price}}<span class='beforePrice' v-if='cartItem.pay_price!=cartItem.total_price'>¥{{cartItem.total_price}}</span></div>
                </div>
                <div class='cartState' @click='handleCart(cartItem.id)' >
                      <div class='cartState1' v-if='!cartItem.showGoods'>
                            <span>查看详情</span>
                            <img src="../assets/icon-next2.png"></img>
                      </div>
                      <div class='cartState2' v-else>
                            <span>点击收起</span>
                            <img src="../assets/icon-next2.png"></img>
                      </div>
                </div>
            </div>

            <!-- 橘袋产品 -->
            <div class="orderMadeproducts"  v-if='cartItem.showGoods'>
                <div class="orderMadeproduct" v-for='cartGoodsItem in cartItem.goods_info' >
                    <div class="goodsImg">
                        <img :src="cartGoodsItem.minshrink_img"/>
                    </div>
                    <div class="goodsContent">
                        <div class="goodsLeft">
                            <div class="goodsName">{{cartGoodsItem.goods_name}}</div>
                            <div class="goodsUse">每袋{{cartGoodsItem.goods_num}}颗
				<span style='margin-left:0.2rem;'> × {{cartItem.buy_days}}袋</span><span style='margin-left:0.2rem;' v-if='cartItem.num!=1'>({{cartItem.num}}套)</span></div>
                            <div class="goodsRemarks" v-if='cartGoodsItem.status==2' >{{cartGoodsItem.advance_sale_remarks}}</div>

                        </div>
                        <div class="goodsPrice">¥ {{cartGoodsItem.goodsPrice}}</div>
                    </div>
                </div>
            </div>

    </div>
    
</div>



<div class="messageBox">
    <div class="message" >
            <div class='messageName'>优惠券:</div>
            <input type="text" placeholder="请输入兑换码" maxlength='20'  v-model="couponCode"  @input='inputCouponCode' cursor-spacing='30'  class='messageTitle' style='width:5.1rem;'/>
            <div class="couponBtn" :class="couponBtnShow?'couponBtnLeft':'couponBtnRight'"  @click='couponCodePost'>兑换</div>
    </div>
    <div  class='line'></div>
    <div class="message">
        <div class='messageName'>留 <span></span> 言：</div>
        <input type="text" placeholder="请输入留言" maxlength='20'   v-model="leaving" cursor-spacing='30'  class='messageTitle' style='width:5.1rem;'/>
    </div>
</div>


<div class='orderMadeBox'>
    <div class='orderRow' >
          <div class='orderRowName'>商品原价</div>
          <div class="orderRowTxt" >{{originalPrice}}元</div>
    </div>
    <div class='orderRow' v-if='planPrice!="0.00"&&planPrice!=0'>
          <div class='orderRowName' >方案优惠</div>
          <div class="orderRowTxt" >- {{planPrice}}元</div>
    </div>
     <div class='orderRow'  @click='showTaxationBtn'>
          <div class='orderRowName'>关税<img class='taxationImg' src='../assets/taxationImg.jpg' ></img></div>
          <div class="orderRowTxt" >+ {{tariff}}元</div>
    </div>
     <div class='orderRow'>
          <div class='orderRowName'>运费</div>
          <div class="orderRowTxt" >保税免费直邮</div>
    </div>
     <div class='orderRow' v-if='memberDiscount!="0.00"'>
          <div class='orderRowName'>会员优惠</div>
          <div class="orderRowTxt">- {{memberDiscount}}元</div>
    </div>
     <div class='orderRow' v-if='saleDiscount!="0.00"'>
          <div class='orderRowName'>{{applyTitle}}</div>
          <div class="orderRowTxt">- {{saleDiscount}}元</div>
    </div>
    <div class='orderRow' v-if='couponDiscount!="0.00"'>
          <div class='orderRowName' @click="delCoupon"><span>优惠（{{couponRes.title}}）  </span><img class='couponDelImg' src='../assets/del-group.png' ></img></div>
          <div class="orderRowTxt">-{{couponDiscount}}元</div>
    </div>
</div>




<div class="order-bar--pad"></div>
<div class="order-bar">
    <div class="payTotal">
        <div class="payTotalPrice">合计 ￥<span> {{payPrice}}</span></div>
        <div class="payTotalTxt"><span v-if='allDiscount>0'>已优惠{{allDiscount}}元，</span>保税区免费直邮</div>
    </div>
        <div  class="payBtn"  @click='createOrderBtn' v-if='address'>确认支付</div>
        <div  class="payBtn" v-else bindtap='addAddress'>{{payPrice>0?"确认支付":"确认购买"}}</div>
      
</div>


		<div class='orderSureBox' v-if='orderSureShow'>
		   	<div class='orderSureTitle'>请确认支付已完成</div>
		   	<div class='orderSureBtn' @click="sureOrderPay">确定</div>
		   </div>
		   <div class='orderSurePop' v-if='orderSureShow'></div>
		   
			<div class='orderSureBox' v-if='QQShow'>
		   	<div class='orderSureTitle'>支付出现了问题，请更换浏览器重试</div>
		   	<div class='orderSureBtn' @click="closeQQShow">确定</div>
		   </div>
		   <div class='orderSurePop' v-if='QQShow'></div>


<!-- 税费说明 -->
	<div class='taxationTitle' :class='showTaxation?"showTaxation":""'>
		<div class='taxationTitleName'>税费说明：</div>
		<div class='taxationTitleTxt'>1.跨境进口需缴纳9.1%的跨境电商综合税。</div>
		<div class='taxationTitleTxt'>2.跨境电商综合税须按一般贸易增值税及消费税税额的70%征收，税费以提交订单时的金额为准。</div>
		<div class='taxationTitleTxt'>3.根据跨境电子商务零售进口税收政策，自2019年1月1日起，个人单笔交易限值人民币5000元，个人年度交易限值人民币26000元。</div>
		<div class='taxationTitleCen'  @click='hideTaxationBtn'>
		          <img src='../assets/del-group.png'></img>
		</div>
	</div>
	<div class='mask' v-if='showTaxation' @click='hideTaxationBtn'></div>
</div>
</template>
<script>
import myAddress from '@/components/myAddress.vue'
import Alert from '@/popup/Alert.vue'
import GoodsShortage from '@/popup/goodsShortage.vue'
import plugin from '@/components/plugin.vue'
export default {
  name: 'orderMade',
  components: {
  		myAddress,
		Alert,
		GoodsShortage,
		plugin
  },
  data:function () {
    return{
		address:{},
		cartList:[],
		originalPrice:"",
		planPrice:"",
		tariff:"",
		leaving:"", 				//留言
		memberDiscount:"",
		saleDiscount:"",
		couponDiscount:"",
		couponRes:{},
		couponids:0,
		couponCode:"",
		applyTitle:"",
		payPrice:0,
		allDiscount:0,
		orderSureShow:false,
		myAddressShow:false,        //选择我的地址
		addressCount:false,       	//是否可以选择我的地址列表
		otherAddressMark:false,   	//是否有其他地址
		otherAddressShow:false,   	//选择其他地址
		couponBtnShow:false,        //优惠券兑换按钮
		showTaxation:false,         //关税说明
		AlertShow:false,			//普通提示
		alertMsg:"",
		selloutShow:false,			//预售缺货
		selloutMsg:{},
		secondCheck:false,
		loadShow:false,
		QQShow:false,             //qq浏览器提示
		isQQ:false,
		isAndroid:true,
    }
  },
  
  
  beforeCreate:function() {
	  if(!this.$route.params.cartids){
	    this.$router.go(-1)
	  }else{
		  this.cart_ids = this.$route.params.cartids
	  }
	
	  
  },
  created:function(){
	  if(this.$route.params.secondCheck){
	  		  this.secondCheck= true
	  }
	this.getaddressList()
	this.getCartArry()
	this.checkGoodsInfo()
	this.downApp()
  },
  
  methods: {
	  downApp() {
	          let ua = navigator.userAgent.toLowerCase();
	          //Android终端
			  
	          this.isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1||ua.indexOf('android') > -1;  
	
	  
	    },

	getaddressList: function () {
    		let that = this
    		this.axios({
	                  method: 'post',
	                  url:"Address/getAddressList",
	                  data:{
	                     member_id:this.$store.state.member_id 
	                  }
	                }).then(res=>{
			let _address = {}
        res.data.addressList.forEach((item) => {
          if (item.is_default == 1) {
            _address = item
          }
        })
        if (!_address.name) {
          _address = res.data.addressList[0]
        }
        if (!_address) return
			this.address= Object.assign({},_address)
		})
  	},
	getCartArry(){
		let that =this
	 	this.axios({
	                  method: 'post',
	                  url:"Allcart/settleAccounts",
	                  data:{
	                     cart_ids:this.cart_ids
	                  }
	                }).then(res=>{
	                    	let _cartList = res.data.cart_list
							if(res.data.cart_list.length<1){
								that.$router.go(-1)
							}
							  for (let i = 0; i < _cartList.length;i++){

								if (res.data.cart_list[i].address){
								  // that.setData({
								  //   cartAddress: res.data.cart_list[i].address,
								  // })
								  if (res.data.cart_list[i].address.member_id != wx.getStorageSync('member_id')){
									_cartAddressList.push(res.data.cart_list[i].address)
								  }
								}
								_cartList[i].total_price = that.base.changeNumber(Number(_cartList[i].total_price) * Number(_cartList[i].num))
								_cartList[i].pay_price = that.base.changeNumber(Number(_cartList[i].pay_price) * Number(_cartList[i].num))
								_cartList[i].showGoods = false
								for (let j = 0; j < _cartList[i].goods_info.length;j++){
								  _cartList[i].goods_info[j].goodsPrice = Number(_cartList[i].goods_info[j].goods_num) * Number(_cartList[i].goods_info[j].goods_price) * Number(_cartList[i].plan_discount) * Number(_cartList[i].buy_days) * Number(_cartList[i].meal_discount) * Number(_cartList[i].num)
								  _cartList[i].goods_info[j].goodsPrice = that.base.changeNumber(_cartList[i].goods_info[j].goodsPrice)

								  if (_cartList[i].goods_info[j].status==2){
									_cartList[i].msgCode=2
								  }
								}
							  }
	                   	this.cartList = res.data.cart_list
          	
	      			})
	},
	// 忽略缺货后
	toMadeOrderPage(cart_ids){
		this.secondCheck = true
		this.selloutShow = false
		this.cart_ids= cart_ids
		this.checkGoodsInfo()
	}, 
	// 删除缺货后
	toCreateOrder(cart_ids){
		this.cart_ids = cart_ids
		this.checkGoodsInfo()
		this.getCartArry()
	},
	getMsgFormSellout(msg){
		this.selloutShow = msg
	},
	checkGoodsInfo(){
		let that =this
		this.loadShow = true
		this.axios({
	                  method: 'post',
	                  url:"Allcart/checkCart",
	                  data:{
	                        member_id: this.$store.state.member_id ,
							coupon_id: this.couponids || 0,
							cart_ids: this.cart_ids,
	                  }
	                }).then(res=>{
						that.loadShow = false
						if (res.data.code == 3) {   //产品已下架或售罄
								   
						that.selloutShow=true
						that.selloutMsg = Object.assign({},{
									msg: res.data.msg,
									msgArr:res.data.msgArr,
									cart_ids: that.cart_ids,
									msgCode:3
							  })
							  return
						}
						if (res.data.code == 2) {   //产品正在预售中
						console.log("检查2",that.secondCheck)
							if(!that.secondCheck){
								that.selloutShow=true
								that.selloutMsg= Object.assign({},{
													msg: res.data.msg,
													msgArr:res.data.msgArr,
													cart_ids: that.cart_ids,
													msgCode:2
								 })
								 return
							}
						}
	                   	let _allDiscount = Number(res.data.totalPrice) + Number(res.data.tariff) - Number(res.data.payPrice)
      
        
          			that.totalPrice=res.data.totalPrice                 //商品总价
          			that.originalPrice= res.data.originalPrice                 //商品原价
          			that.planPrice= (Number(res.data.originalPrice) - Number(res.data.totalPrice)).toFixed(2)     //方案优惠
          			that.payPrice= Number(res.data.payPrice)                     //实际支付
          			that.tariff= Number(res.data.tariff)                         //税费
          			that.memberDiscount= Number(res.data.memberDiscount)         //会员优惠
         			that.couponDiscount= Number(res.data.couponDiscount)         //优惠券
          			that.couponRes= res.data.couponRes || "优惠券"                //优惠券信息
          			that.saleDiscount= Number(res.data.saleDiscount)             //专业人士优惠价格
          			that.applyTitle= res.data.applyTitle || "专业人士优惠"        //专业人士优惠描述
          			that.couponCode= ""                                          //兑换码置空
          			that.allDiscount= that.base.changeNumber(_allDiscount)                           //总优惠金额
    
          	
	      			})
	},
	handleCart(cartid){
		let _cartList = this.cartList
		let indexOfItem = 0
		let newValue = {}
		_cartList.forEach((item,index)=>{
			if(cartid==item.id){
				indexOfItem = index
				newValue =item
			
			}
		})
		this.cartList[indexOfItem].showGoods = !this.cartList[indexOfItem].showGoods;
		this.$set(this.cartList , indexOfItem , this.cartList[indexOfItem]);
	
	},
	// 选择其他地址
	changeAddress(){
		this.myAddressShow = true
		
	},
	// 创建订单
	createOrderBtn(){
		let that =this
		if(!this.address.name){
			that.alertMsg = '请添加收货地址'
			that.AlertShow = true
			return
		}
		let _isWeiXin = this.isWeiXin()
		
		if(_isWeiXin ==3){
			this.QQShow= true
			return
		}
		this.axios({
		              method: 'post',
		              url:"H5api/createOrder",
		              data:{
		                    member_id: this.$store.state.member_id ,
							address_id: this.address.id ,
							order_remark:this.leaving,
							cart_ids: this.cart_ids,
							coupon_id:this.couponids || 0,
							order_type:1,
							share_id:0,
							pay_type:_isWeiXin,  // 1微信支付，2支付宝支付
		              }
		            }).then(res=>{
						if(_isWeiXin==1){
							that.H5params = res.data.params
							this.weixinpay()
						}else{
							that.H5params = res.data.resultPay
							this.zhifubaopay()
						}
						
					})
		
		
	},
	changeAddressFN(event){

		this.address= Object.assign({},event)
		this.myAddressShow = false
	},
	// 拉起微信h5支付
	weixinpay(){
		let _H5params = this.H5params
		console.log(this.H5params)
		let _url   = "https://syb.allinpay.com/apiweb/h5unionpay/unionorder?"
		_url=  _url + "cusid="+ _H5params.cusid
		_url=  _url + "&appid="+ _H5params.appid
		_url=  _url + "&version="+ _H5params.version
		_url=  _url + "&trxamt="+ _H5params.trxamt
		_url=  _url + "&reqsn="+ _H5params.reqsn
		_url=  _url + "&charset="+ _H5params.charset
		_url=  _url + "&returl="+ _H5params.returl
		_url=  _url + "&notify_url="+ _H5params.notify_url
		_url=  _url + "&body="+ _H5params.body
		_url=  _url + "&remark="+ _H5params.remark
		_url=  _url + "&randomstr="+ _H5params.randomstr
		_url=  _url + "&validtime="+ _H5params.validtime
		_url=  _url + "&limit_pay="+ _H5params.limit_pay
		_url=  _url + "&sign="+ _H5params.sign
		
		
		if(this.isAndroid ){
			window.open(_url )
		}else{
			window.location.href = _url
		}
		
		
	},
	// 拉起支付宝h5支付
	zhifubaopay(){
		let _H5params = this.H5params
		// 
		if(this.isAndroid ){
			window.open(_H5params.payinfo)
		}else{
			window.location.href=_H5params.payinfo
		}
		
		this.orderSureShow = true
	},
	
	isWeiXin() {
	        let ua = window.navigator.userAgent.toLowerCase();
			let _return = 1
	        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
	            _return = 1 // 是微信端
	        } else {
	            _return = 2 // 非微信端
	        }
			if(ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null){
				this.isQQ = true   // QQ浏览器
				  _return = 1
			}
			
			return _return
			
	},
	closeOrderPay(){
		this.orderSureShow = false
	},
	
	// 输入优惠券
	inputCouponCode(e){
	
		this.couponCode = e.target.value
		if(e.target.value.length>0){
			this.couponBtnShow = true
		}else{
			this.couponBtnShow = false
		}
		
	},
	// 兑换优惠券
	couponCodePost(){
		let that = this
		this.axios({
			method: 'post',
			url:"Coupon/exchangeCoupon",
			data:{
			   member_id: this.$store.state.member_id,
			   cart_ids: this.cart_ids,
			   code: this.couponCode,
			}
		}).then(res=>{
			  that.couponCode =""
		      if (res.data.code == 0) {
				   that.alertMsg = res.data.msg
				   that.AlertShow = true
		        return
		      }
		      if (that.couponDiscount != "0.00") {
				  that.alertMsg = '此优惠券不可与当前券共用'
				  that.AlertShow = true
		        return
		      }
				that.alertMsg = '优惠券兑换成功'
				that.AlertShow = true
		        that.couponids= res.data.coupon_id,
		        that.couponTitle= res.data.title
		      that.checkGoodsInfo()
		      
		    })
	},
	// 删除优惠券
	delCoupon(){
		this.couponids= 0
		this.couponTitle="" 
		this.checkGoodsInfo()
	},
	sureOrderPay(){
		this.orderSureShow = false
		this.$router.push({
			name: 'orderList',
			params: {}
		})
	},
	// 显示关税提示
	showTaxationBtn(){
		this.showTaxation = true
	},
	// 隐藏关税提示
	hideTaxationBtn(){
		this.showTaxation = false
	},
	closeAlertShow(){
	  this.AlertShow = false
	},
	// 点击取消删除缺货
	cancelCreateOrder(){
			this.$router.go(-1)  
	},
	closeQQShow(){
		this.QQShow = false
	},
  }
}
</script>
<style>
#orderMade{
  background:rgba(244,242,240,1);
  width: 7.5rem;
  height: 100vh;
  
  margin: 0 auto;
  text-align: left;
  overflow-y: auto;	
}
#orderMade::-webkit-scrollbar {display:none}
/* 地址 */
.loading{
	width: 7.5rem;
	height: 100vh;
	position:absolute;
	z-index: 900;
	background:rgba(0,0,0,0.5);
	line-height:100vh ;
	color: #fff;
	font-size: 0.32rem;
	text-align: center;
}
.orderMadeAddress {
    position: relative;
    box-sizing: border-box;
    width:7.5rem;
    min-height:2.4rem;
    background:rgba(255,255,255,1);
    box-shadow:0px 16px 30px 0px rgba(0,0,0,0.04),0px 0px 4px 0px rgba(0,0,0,0.08);
    padding: 0.4rem 0.35rem; 
}
.address-bg {
    width: 100%;
    position: relative;
    z-index: 2;
    pointer-events: none;
}
.orderMadeAddress .container1 .orderMadeAddresscontent{
  display: flex;
}
.contentLeft{
  width:0.4rem;
  height:0.5rem;
}
.contentLeft img{
  width:0.4rem;
  height:0.5rem;
}
.contentRight{
  width:0.18rem;
  height:0.31rem;
  padding-top: 0.66rem;
}
.contentRight img{
  width:0.18rem;
  height:0.31rem;
}
.contentCenter{
  flex: 1;
  margin-left: 0.31rem;
}
.contentCenterprovince{
  font-size:0.24rem;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(120,120,120,1);
  line-height:0.33rem;
  margin-bottom: 0.1rem;
}
.contentCenteraddress{
  font-size:0.3rem;
  font-family:PingFangSC-Medium;
  font-weight:600;
  color:rgba(20,20,20,1);
  line-height:0.42rem;
  margin-bottom: 0.16rem;
}
.contentCenterName{
  font-size:0.24rem;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(120,120,120,1);
  line-height:0.33rem;
  text-shadow:0px 1px 3px rgba(0,0,0,0.1);
  display: flex;
  margin-bottom: 0.1rem;
}
.contentCenterName div{
  margin-right: 0.16rem;
}
.content2{
    /* display: flex;
    align-items: center;
    justify-content: center; */
    position: relative;
    top:0.2rem;
    height: 1.2rem;
    line-height: 0.6rem;
    text-align: center;
    color: rgba(51, 51, 51, 1);
}



.cart-box {
    background: #fff;
    padding: 0 0.4rem;
    margin-bottom: 0.2rem;
}
.cart {
    padding: 0.3rem 0;
    display: flex;
    border-bottom: 1rpx solid rgba(244,242,240,1);
    position: relative;
    margin-bottom: 0.2rem;
}
.cartImg {
    width: 1.7rem;
    height: 1.7rem;
}
.cartImg img {
    width: 100%;
    height: 100%;
    border-radius: 0.1rem;
    flex-shrink: 0;
}
.cart .content {
    padding-left: 0.35rem;
    flex-grow: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.cart .content .title {
    font-size:0.32rem;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(20,20,20,1);
    line-height:0.45rem;
}
.cart .content .time {
    font-size:0.24rem;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(155,155,155,1);
    line-height:0.33rem;
}
.cart .content .price {
    width: 3.8rem;
    font-size:0.32rem;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(194,94,77,1);
}
.cart .content .price span {
    font-size: 0.26rem;
    font-weight: normal;
}
.beforePrice{
  font-size:0.2rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(137,137,137,1);
  text-decoration: line-through;
  margin-left: 0.1rem;
}
.cartState{
  position: absolute;
  bottom:0;
  right:-0.16rem;
  padding: 0.35rem 0.4rem;
}
.cartState div{
  height:0.3rem;
  font-size:0.22rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(142,142,142,1);
  line-height:0.3rem;
}
.cartState img{
  width:0.1rem;
  height: 0.2rem;
  position: relative;
  left: 0.16rem;
  top:0;
}
.cartState1 img{
  transform: rotate(90deg);
}
.cartState2 img{
  transform: rotate(270deg);
}




.orderMadeproducts .orderMadeproduct {
    padding: 0.12rem 0;
    display: flex;
}
.orderMadeproduct .goodsImg {
    width: 1rem;
    height: 1rem;
}
.orderMadeproduct  .goodsImg img {
    width: 100%;
    height: 100%;
    border-radius: 0.1rem;
}
.orderMadeproduct .goodsContent {
    text-align: left;
    margin-left: 0.24rem;
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(244,242,240,0.3);
    padding-bottom: 0.25rem;
}
.orderMadeproduct .goodsName {
    font-size:0.28rem;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(20,20,20,1);
    line-height:0.48rem;
    margin-bottom: 0.16rem;
}
.orderMadeproduct .goodsUse{
    font-size:0.24rem;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(155,155,155,1);
    line-height:0.33rem;

}
.goodsLeft{
  flex: 1;
}
.goodsRemarks{
  
  padding-top: 0.16rem;
    font-size:0.24rem;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(194,94,77,1);
    line-height:33rpx;
}
.goodsPrice {
  width: 1.8rem;
  text-align: right;
    font-size:0.28rem;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:0.4rem;
    letter-spacing:1px;
}




.messageBox{
background: #fff;
width:7.5rem;
overflow: hidden;
margin-bottom: 0.2rem;
}
.message {
    display: flex;
    align-items: center;
    padding: 0.3rem 0.4rem;
    font-size: 0.3rem;
    box-sizing: border-box;
    width:7.5rem;
	overflow: hidden;
	position:relative
}
.messageName{
    width:1.6rem !important;
	
    font-size: 0.3rem;
    height: 0.6rem;
    line-height: 0.6rem;

    text-align: justify !important;
}

.messageTitle{
    /* width:5.1rem; */
	/* flex:1 ; */
	width:5.1rem !important;
    font-size: 0.3rem;
    height: 0.6rem;
	text-align: left;
    line-height: 0.6rem;
}
.line{
  width:6.7rem;
  height:0.02rem;
  background:rgba(244,242,240,1);
  margin:0 auto;
}
.couponBtn{
    position: absolute;
    background-color: #C25E4D;
    color: #fff;
    border-radius: 1rem;
    width: 1.8rem;
    line-height: 0.6rem;
    font-size: 0.24rem;
    overflow: visible;
    font-weight: 500;
    text-align: center;
    letter-spacing:1rpx;
    transition: all .6s;
}
.couponBtnRight{
  right: -4rem;
}
.couponBtnLeft{
  right: 0.5rem;
}
.placeholderClass{
  font-size:0.28rem;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(74,74,74,0.8);
  line-height:0.7rem;
}
input{
  height: 0.6rem;
  line-height:0.6rem;
  font-size:0.3rem;
}
#orderMade .orderMadeBox{
  background: #fff;
  padding: 0 0.4rem;
  margin-bottom: 0.2rem;
}


.orderRow{
  height: 1rem;
  line-height: 1rem;
  display: flex;
  justify-content: space-between;
  border-bottom:0.01rem solid rgba(244,242,240,1); 
}
.orderRowName{
  height: 1rem;
  font-size:0.3rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(20,20,20,1);
  position: relative;
}
.orderRowTxt{
  height: 1rem;
  font-size:0.28rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(120,120,120,1);
}
.couponDelImg{
  position: absolute;
  top:0.45rem;
  right: -0.4rem;
  width:0.2rem;
  height: 0.2rem;
}




.taxationImg{
  position: absolute;
  top:0.37rem;
  right: -0.4rem;
  width: 0.28rem;
  height: 0.28rem;
}
.taxationTitle{
  width: 7.5rem;
  height: 3.8rem;
  padding: 0.3rem 0.6rem 0px;
  box-sizing: border-box;
  background-color: #fff;
  position: fixed;
  top:-3.8rem;
  z-index: 100;
  transition: all 0.6s;
}
.taxationTitleName{
  font-size:0.28rem;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(95,95,95,1);
  line-height:0.4rem;
  margin-bottom: 0.3rem;
}
.taxationTitleTxt{
  font-size:0.24rem;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(95,95,95,1);
  line-height:0.33rem;
  margin-bottom: 0.2rem;
}
.taxationTitleCen{
  width: 0.25rem;
  height: 0.25rem;
  padding: 0.35rem;
  position: absolute;
  top:0;
  right: 0.2rem;
}
.taxationTitleCen img{
   width: 0.25rem;
  height: 0.25rem;
  display: block;
}
.mask{
  width: 7.5rem;
  height:100vh;
  position: fixed;
  top:0;
  left: 50%;
  transform: translate(-50%,0); 
  background:rgba(0, 0, 0, 0.6);
  z-index: 99;
}
.showTaxation{
  top:4rem;
}


.order-bar--pad {
    height: 1.8rem;
}
.order-bar {
    position: fixed;
    width: 7.5rem;
    left: 50%;
    transform: translate(-50%, 0); 
    bottom: 0;
    width:7.5rem;
    box-sizing: border-box;
    bottom: 0;
    padding: 0.4rem 0.4rem 0.5rem;
    background: #fff;
    box-shadow: 0px -6px 20px 0px rgba(0,0,0,0.08);
    display: flex;
    justify-content: space-between;
    z-index: 90;
}
.payTotal {
    flex: 1;
    height: 0.88rem;
    text-align: left;
    width: 38%;
    font-size:0.32rem;
    color:rgba(194,94,77,1);
}
.payTotalPrice{
  font-size:0.34rem;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(20,20,20,1);
  line-height:0.48rem;
}
.payTotalPrice text{
  font-weight:bold;
}
.payTotalTxt{
  font-size:0.24rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(155,155,155,1);
  line-height:0.33rem;
}
.payBtn{
  width:2.1rem;
  line-height: 0.88rem;
  text-align: center;
  height:0.88rem;
  background:rgba(194,94,77,1);
  box-shadow:0px 5px 15px 0px rgba(237,196,185,0.35);
  border-radius:0.43rem;
  font-size:0.3rem;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(255,255,255,1);
}
.createBtn{
  background:#ccc;
}

.orderSureBox{
	width: 5.5rem;
	padding: 0.5rem;
	position: fixed;
	left: 50%;
	top:50%;
	transform: translate(-50%, -50%);  
	background-color: #fff;
	border-radius: 0.2rem;
	z-index: 100;
}
.orderSureTitle{
	line-height: 1rem;
	text-align: center;
	font-size: 0.28rem;
	color: #333333;
	font-family:PingFangSC-Medium,PingFang SC;
}
.orderSureBtn{
	width:2.1rem;
	line-height: 0.6rem;
	text-align: center;
	height:0.6rem;
	background:rgba(194,94,77,1);
	box-shadow:0px 5px 15px 0px rgba(237,196,185,0.35);
	border-radius:0.43rem;
	font-size:0.26rem;
	font-family:PingFangSC-Medium,PingFang SC;
	font-weight:500;
	color:rgba(255,255,255,1);
	margin: 0 auto;
}
.orderSurePop{
	width: 7.5rem;
	height: 100vh;
	background: rgba(0, 0, 0, 0.5);
	position: fixed;
	left: 50%;
	top:0;
	transform: translate(-50%, 0);  
	z-index: 99;
}
</style>